import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MojoTagModule } from 'mojo-tag';

import { MultipleLocationInputComponent } from './multiple-location-input.component';

const containers = [MultipleLocationInputComponent];
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatIconModule,
    MojoTagModule,
  ],
  exports: [...containers],
  declarations: [...containers],
})
export class MultipleLocationInputModule {}
